
export function formValidation(formType, form){

	class ValidateForm {
		constructor(form) {
			this.Form = form;
		}

		validate() { }
	}

	class DefaultValidateForm extends ValidateForm {
		constructor(form) {
			super(form);
		}

		validate() {
			const errors = [...form.querySelectorAll('.validate:not(.valid)')].reduce((html, item) => {
				return html + h('p', (item.placeholder ? item.placeholder.replace('*', '') : item.getAttribute('placeholder') || item.parentNode.querySelector('label').textContent.replace('*', '')) + ' Required').toString();
			}, '');

			if (errors.length > 0) {
				form.querySelector('.errors').innerHTML = errors;
				return false;
			}

			return true;
		}
	}

	class TruckLeadValidateForm extends ValidateForm {
		constructor(form, formType) {
			super(form);

			this.alphaNumericRegex = /^[a-zA-Z0-9]+$/;
			this.emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			this.noNumbersRegex = /^([^0-9]*)$/;
			this.noSpacesRegex = /^\S*$/;
			this.noSpecialCharsRegex = /^[^<>=;]+$/;
			this.num8Regex = /^[0-9]{8}$/;
			this.numericRegex = /^\d+$/;
			this.phoneExtRegex = /^\d{1,4}$/;
			this.postalCodeRegex = /^[a-zA-Z0-9]{1,20}$/;
			this.formType = formType;
			const messageContainer = this.Form.querySelector('.errors');			
			this.MessageContainer = messageContainer
				? messageContainer
				: { innerHTML: '' };
		}

		fieldListEvent(event, target) {
			const field = target ? target : event.target;

			const isValid = this.processField(field);
		}

		processField(field) {
			const isValid = this.validateField(field);

			if (isValid)
				this.setFieldToValid(field);
			else
				this.setFieldToInvalid(field);

			return isValid;
		}

		setEventListener(field) {
			const validateType = field.getAttribute('requiredtype');

			switch (validateType) {
				case 'dealer':
					const eventField = document.getElementById('DealerCode');
					if (eventField)
						eventField.addEventListener
							('dealer-change', (event) => { this.fieldListEvent(event, field); });
					break;

				default:
					field.addEventListener
						('blur', (event) => { this.fieldListEvent(event, field) });
					break;
			}
		}

		setFieldToInvalid(field) {

			field.classList.add('invalid');

			this.setEventListener(field);

			const msg = field.getAttribute("invalidmessage");
			if (msg && msg !== '') {
				const options = {
					content: msg,
					trigger: 'focusin',
					placement: 'top-start'
				};

				if (this.formType === 'Configurator')
					options.appendTo = this.Form;

				tippy(field, options);
			}
		}

		setFieldToValid(field) {
			field.classList.remove('invalid');
		}

		setFocus(field) {
			const validateType = field.getAttribute('requiredtype');

			switch (validateType) {
				case 'dealer':
					const locationField = document.getElementById('DealerLocation');
					if (locationField)
						locationField.focus();
					break;

				default:
					field.focus();
					break;
			}
		}

		validate() {
			try {
				const errorFields = [];
				const fields = [...this.Form.querySelectorAll('[validate="onsubmit"]')];
				
				for (let i = 0, l = fields.length; i < l; i++) {
					const isValid = this.processField(fields[i]);
					if (!isValid)
						errorFields.push(fields[i]);
				}

				if (errorFields.length > 0) {
					this.setFocus(errorFields[0]);
					return false;
				}

				return true;

			} catch (exception) {
				console.error(exception);
				return false;
			}
		}

		validateComments(value) {
			if (typeof value === 'string') {
				if (value.length === 0)
					return true;

				return value.length <= 1000
					&& this.noSpecialCharsRegex.test(value)
			}

			return false;
		}

		validateEmail(value) {
			if (typeof value === 'string')
				return value.length > 0
					&& value.length <= 50
					&& value.match(this.emailRegex)
					&& this.noSpacesRegex.test(value)
					&& this.noSpecialCharsRegex.test(value);
			return false;
		}

		validateField(field) {
			const validateType = field.getAttribute('requiredtype');

			switch (validateType) {
				case 'comments':
					return this.validateComments(field.value);

				case 'company':
					return this.validateText(field.value);

				case 'dealer':
					const dealerCodeField = document.getElementById('DealerCode');
					const dealerCode = dealerCodeField ? dealerCodeField.value : '';
					return this.validateText(dealerCode);

				case 'email':
					return this.validateEmail(field.value);

				case 'name':
					return this.validateName(field.value);

				case 'num8Pattern':
					return this.validateNum8(field.value);

				case 'postalcode':
					return this.validatePostalCode(field.value);

				case 'tel':
					return this.validatePhone(field.value);

				case 'sel':
				case 'text':
					return this.validateText(field.value);

				case 'state':
					const countryElement = document.getElementById('BusinessCountry');
					const country = countryElement ? countryElement.value : '';
					return this.validateState(country, field.value);

				case 'website':
					return this.validateWebsite(field.value);
			}

			return true;
		}

		validateName(value) {
			const name = typeof value === 'string'
				? value
				: String(value);

			return name.length > 0
				&& name.length <= 50
				&& this.noNumbersRegex.test(name)
				&& this.noSpecialCharsRegex.test(name)
				&& this.noSpacesRegex.test(name);
		}

		validateNonRequired(value, length) {
			if (typeof value !== 'string')
				value = String(value);

			if (value.length === 0)
				return true;

			if (!length)
				length = 50;

			return value.length <= length
				&& this.noSpecialCharsRegex.test(value);
		}

		validateNum8(value) {
			const str = typeof value === 'string'
				? value
				: String(value);

			if (str.length > 0)
				return str.length === 8 && str.match(this.alphaNumericRegex);

			return true;
		}

		validatePhone(value) {
			let phone = typeof value === 'string'
				? value
				: String(value);

			phone = phone.replace(/\D/g, '');

			return phone.length >= 10;
		}

		validatePostalCode(value) {
			const code = typeof value === 'string'
				? value
				: String(value);

			return this.postalCodeRegex.test(code);
		}

		validateState(country, state) {
			if (country === 'US' || country === 'CA')
				return state.length >= 2
					&& this.noNumbersRegex.test(state)
					&& this.noSpecialCharsRegex.test(state)
					&& state.length <= 50;

			if (state.length === 0)
				return true;

			return this.noNumbersRegex.test(state)
				&& this.noSpecialCharsRegex.test(state)
				&& state.length <= 50;
		}

		validateText(value, length) {
			if (!length)
				length = 50;

			if (typeof value === 'string')
				return value.length > 0
					&& value.length <= length
					&& this.noSpecialCharsRegex.test(value);

			return false;
		}

		validateWebsite(value) {
			if (typeof value !== 'string')
				value = String(value);

			if (value.length === 0)
				return true;

			return value.length <= 200
				&& this.noSpecialCharsRegex.test(value)
				&& this.noSpacesRegex.test(value);
		}
	}

	return formType === 'TruckLead'
		|| formType === 'Newsletter'
        || formType === 'Cascadia'
		|| formType === 'DownloadGuide'
		|| formType === 'Configurator'
        || formType === 'RCO'
        || formType === 'TRS'
		? new TruckLeadValidateForm(form, formType)
		: new DefaultValidateForm(form);
}
